/**
 * Iliria Security — Ajax Alarm Configurator
 * Version: 3.4.0
 */

(() => {
  "use strict";

  const CONFIG = {
    version: "3.4.0",

    products: {
      hub2: {
        name: "Ajax Hub 2",
        price: 210,
        installation: 0,
        colors: ["white", "black"]
      },
      keypad: {
        name: "Ajax KeyPad",
        price: 90,
        installation: 0,
        colors: ["white", "black"]
      },
      homesiren: {
        name: "Ajax HomeSiren",
        price: 55,
        installation: 0,
        colors: ["white", "black"]
      },
      streetsiren: {
        name: "Ajax StreetSiren DoubleDeck",
        price: 120,
        installation: 0,
        colors: ["white"]
      },
      doorprotect: {
        name: "Ajax DoorProtect",
        price: 35,
        installation: 10,
        colors: ["white", "black"]
      },
      motionprotect: {
        name: "Ajax MotionProtect",
        price: 55,
        installation: 10,
        colors: ["white", "black"]
      },
      motioncam: {
        name: "Ajax MotionCam",
        price: 130,
        installation: 10,
        colors: ["white", "black"]
      },
      fireprotect: {
        name: "Ajax FireProtect 2 RB CO",
        price: 110,
        installation: 10,
        colors: ["white", "black"]
      },
      leaksprotect: {
        name: "Ajax LeaksProtect",
        price: 45,
        installation: 10,
        colors: ["white", "black"]
      },
      spacecontrol: {
        name: "Ajax SpaceControl",
        price: 30,
        installation: 0,
        colors: ["white", "black"]
      },
      panicbutton: {
        name: "Ajax Button Panic",
        price: 30,
        installation: 0,
        colors: ["white", "black"]
      }
    },

    services: {
      baseInstallation: 100,
      simAnnual: 90,
      monitoringMonthly: 12,
      monitoringAnnual: 144
    }
  };

  const DEFAULT_STATE = {
    currentStep: 1,

    propertyType: "",

    entrances: 1,
    balconyDoors: 0,
    windows: 0,

    motionRooms: 1,
    motionCams: 0,

    fireDetectors: 0,
    leakDetectors: 0,

    remotes: 0,
    panicButtons: 0,

    sim: false,
    monitoring: "no",

   colors: {
  hub2: "white",
  keypad: "white",
  homesiren: "white",
  streetsiren: "white",

  doorprotectEntrance: "white",
  doorprotectBalcony: "white",
  doorprotectWindow: "white",

  motionprotect: "white",
  motioncam: "white",
  fireprotect: "white",
  leaksprotect: "white",
  spacecontrol: "white",
  panicbutton: "white"
},

    customer: {
      name: "",
      phone: "",
      email: "",
      area: "",
      notes: ""
    }
  };

  class AjaxConfigurator {
    constructor(root) {
      this.root = root;
      this.state = JSON.parse(JSON.stringify(DEFAULT_STATE));

      this.steps = Array.from(
        this.root.querySelectorAll("[data-step]")
      );

      this.totalSteps = this.steps.length;

      this.moneyFormatter = new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });

      this.bindEvents();
      this.render();
    }

    bindEvents() {
      this.root.addEventListener("click", (event) => {
        const colorChoice = event.target.closest(
          "[data-color-choice]"
        );

        if (colorChoice) {
          this.changeColor(
            colorChoice.dataset.colorFor,
            colorChoice.dataset.colorValue
          );
          return;
        }

        const option = event.target.closest("[data-option]");

        if (option) {
          this.handleOption(option);
          return;
        }

        const counterButton = event.target.closest(
          "[data-counter-action]"
        );

        if (counterButton) {
          this.handleCounter(counterButton);
          return;
        }

        const nextButton = event.target.closest(
          "[data-next-step]"
        );

        if (nextButton) {
          this.nextStep();
          return;
        }

        const previousButton = event.target.closest(
          "[data-prev-step]"
        );

        if (previousButton) {
          this.previousStep();
          return;
        }

        const goToStepButton = event.target.closest(
          "[data-go-to-step]"
        );

        if (goToStepButton) {
          this.goToStep(
            Number(goToStepButton.dataset.goToStep)
          );
        }
      });

      this.root.addEventListener("input", (event) => {
        const target = event.target;

        if (!target.matches("[data-customer-field]")) {
          return;
        }

        const field = target.dataset.customerField;

        this.state.customer[field] = target.value.trim();
        this.syncHiddenFields();
      });

      this.root.addEventListener("change", (event) => {
        const target = event.target;

        if (target.matches("[data-customer-field]")) {
          const field = target.dataset.customerField;

          this.state.customer[field] = target.value.trim();
          this.syncHiddenFields();
        }
      });

      const form = this.root.querySelector(
        "form.ajax-configurator__form"
      );

      if (form) {
        form.addEventListener("submit", (event) => {
          event.preventDefault();
          this.submitConfiguration(form);
        });
      }

      this.root.addEventListener("click", (event) => {
        if (event.target.closest("[data-print-confirmation]")) {
          window.print();
          return;
        }

        if (event.target.closest("[data-new-configuration]")) {
          this.resetConfigurator();
        }
      });
    }

    handleOption(option) {
      const field = option.dataset.option;
      const value = option.dataset.value;

      if (!field) {
        return;
      }

      if (field === "sim") {
        this.state.sim = value === "true";
      } else {
        this.state[field] = value;
      }

      this.enforceRules();
      this.render();
    }

    handleCounter(button) {
      const field = button.dataset.counterAction;
      const direction = button.dataset.direction;

      if (!(field in this.state)) {
        return;
      }

      let value = Number(this.state[field]) || 0;

      if (direction === "increase") {
        value += 1;
      }

      if (direction === "decrease") {
        value -= 1;
      }

      this.state[field] = Math.max(0, value);

      this.enforceRules();
      this.render();
    }

    changeColor(productId, color) {
  const allowedColorFields = [
    "hub2",
    "keypad",
    "homesiren",
    "streetsiren",
    "doorprotectEntrance",
    "doorprotectBalcony",
    "doorprotectWindow",
    "motionprotect",
    "motioncam",
    "fireprotect",
    "leaksprotect",
    "spacecontrol",
    "panicbutton"
  ];

  if (!allowedColorFields.includes(productId)) {
    return;
  }

  if (!["white", "black"].includes(color)) {
    return;
  }

  if (productId === "streetsiren" && color !== "white") {
    return;
  }

  this.state.colors[productId] = color;

  this.renderColorSelectors();
  this.renderSummary();
  this.syncHiddenFields();
}

    enforceRules() {
      const numericFields = [
        "entrances",
        "balconyDoors",
        "windows",
        "motionRooms",
        "motionCams",
        "fireDetectors",
        "leakDetectors",
        "remotes",
        "panicButtons"
      ];

      numericFields.forEach((field) => {
        this.state[field] = Math.max(
          0,
          Number(this.state[field]) || 0
        );
      });

      if (this.state.motionCams > this.state.motionRooms) {
        this.state.motionCams = this.state.motionRooms;
      }
    }

    nextStep() {
      if (!this.validateStep(this.state.currentStep)) {
        return;
      }

      this.goToStep(this.state.currentStep + 1);
    }

    previousStep() {
      this.goToStep(this.state.currentStep - 1);
    }

    goToStep(step) {
      const safeStep = Math.max(
        1,
        Math.min(this.totalSteps, step)
      );

      this.state.currentStep = safeStep;

      this.renderSteps();
      this.renderNavigation();

      const top =
        this.root.getBoundingClientRect().top +
        window.scrollY -
        100;

      window.scrollTo({
        top,
        behavior: "smooth"
      });
    }

    validateStep(step) {
      this.clearMessage();

      if (step === 1 && !this.state.propertyType) {
        this.showMessage(
          "Επιλέξτε πρώτα τον τύπο του χώρου."
        );

        return false;
      }

      return true;
    }

    validateFinalForm() {
      this.clearMessage();

      const name = this.state.customer.name;
      const phone = this.state.customer.phone;
      const email = this.state.customer.email;

      const errors = [];

      if (name.length < 2) {
        errors.push(
          "Συμπληρώστε το ονοματεπώνυμό σας."
        );
      }

      if (!this.isValidPhone(phone)) {
        errors.push(
          "Συμπληρώστε έναν έγκυρο αριθμό τηλεφώνου."
        );
      }

      if (!email || !this.isValidEmail(email)) {
        errors.push(
          "Συμπληρώστε ένα έγκυρο email."
        );
      }

      if (errors.length > 0) {
        this.showMessage(errors.join(" "));
        return false;
      }

      return true;
    }

    isValidPhone(phone) {
      const digits = String(phone).replace(/\D/g, "");
      return digits.length >= 10;
    }

    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    getQuantities() {
  const totalOpenings =
    this.state.entrances +
    this.state.balconyDoors +
    this.state.windows;

  return {
    hub2: 1,
    keypad: 1,
    homesiren: 1,
    streetsiren: 1,

    doorprotect: totalOpenings,

    doorprotectEntrance: this.state.entrances,
    doorprotectBalcony: this.state.balconyDoors,
    doorprotectWindow: this.state.windows,

    motioncam: this.state.motionCams,

    motionprotect: Math.max(
      0,
      this.state.motionRooms - this.state.motionCams
    ),

    fireprotect: this.state.fireDetectors,
    leaksprotect: this.state.leakDetectors,
    spacecontrol: this.state.remotes,
    panicbutton: this.state.panicButtons
  };
}

    getSelectedProducts() {
  const quantities = this.getQuantities();
  const selectedProducts = [];

  Object.entries(CONFIG.products).forEach(([id, product]) => {
    if (id === "doorprotect") {
      return;
    }

    const quantity = quantities[id] || 0;

    if (quantity <= 0) {
      return;
    }

    const color =
      this.state.colors[id] ||
      product.colors[0] ||
      "white";

    selectedProducts.push({
      id,
      ...product,
      quantity,
      color,
      subtotal: quantity * product.price,
      installationSubtotal:
        quantity * product.installation
    });
  });

  const doorProtect = CONFIG.products.doorprotect;

  const doorGroups = [
    {
      id: "doorprotectEntrance",
      name: "Ajax DoorProtect — Είσοδοι",
      quantity: this.state.entrances,
      color: this.state.colors.doorprotectEntrance
    },
    {
      id: "doorprotectBalcony",
      name: "Ajax DoorProtect — Μπαλκονόπορτες",
      quantity: this.state.balconyDoors,
      color: this.state.colors.doorprotectBalcony
    },
    {
      id: "doorprotectWindow",
      name: "Ajax DoorProtect — Παράθυρα",
      quantity: this.state.windows,
      color: this.state.colors.doorprotectWindow
    }
  ];

  doorGroups.forEach((group) => {
    if (group.quantity <= 0) {
      return;
    }

    selectedProducts.push({
      id: group.id,
      name: group.name,
      price: doorProtect.price,
      installation: doorProtect.installation,
      colors: doorProtect.colors,
      quantity: group.quantity,
      color: group.color || "white",
      subtotal:
        group.quantity * doorProtect.price,
      installationSubtotal:
        group.quantity * doorProtect.installation
    });
  });

  return selectedProducts;
}

    calculateTotals() {
      const products = this.getSelectedProducts();

      const equipment = products.reduce(
        (sum, product) => sum + product.subtotal,
        0
      );

      const installationExtras = products.reduce(
        (sum, product) =>
          sum + product.installationSubtotal,
        0
      );

      const installation =
        CONFIG.services.baseInstallation +
        installationExtras;

      const simAnnual = this.state.sim
        ? CONFIG.services.simAnnual
        : 0;

      const monitoringMonthly =
        this.state.monitoring === "yes"
          ? CONFIG.services.monitoringMonthly
          : 0;

      const monitoringAnnual =
        this.state.monitoring === "yes"
          ? CONFIG.services.monitoringAnnual
          : 0;

      const initialTotal =
        equipment +
        installation +
        simAnnual;

      return {
        equipment,
        installation,
        simAnnual,
        monitoringMonthly,
        monitoringAnnual,
        initialTotal
      };
    }

    calculateSecurityScore() {
      let score = 35;

      const openings =
        this.state.entrances +
        this.state.balconyDoors +
        this.state.windows;

      if (openings > 0) {
        score += 15;
      }

      if (this.state.motionRooms > 0) {
        score += 15;
      }

      if (this.state.motionCams > 0) {
        score += 8;
      }

      if (this.state.fireDetectors > 0) {
        score += 8;
      }

      if (this.state.leakDetectors > 0) {
        score += 5;
      }

      if (this.state.sim) {
        score += 7;
      }

      if (this.state.monitoring === "yes") {
        score += 7;
      }

      return Math.min(100, score);
    }

    getSecurityLabel(score) {
      if (score >= 90) {
        return "Πολύ υψηλό επίπεδο προστασίας";
      }

      if (score >= 75) {
        return "Υψηλό επίπεδο προστασίας";
      }

      if (score >= 60) {
        return "Καλό επίπεδο προστασίας";
      }

      return "Βασικό επίπεδο προστασίας";
    }

    getRecommendations() {
      const recommendations = [];

      if (this.state.motionRooms === 0) {
        recommendations.push(
          "Προσθέστε ανίχνευση κίνησης σε βασικούς χώρους."
        );
      }

      if (this.state.fireDetectors === 0) {
        recommendations.push(
          "Εξετάστε την προσθήκη FireProtect 2 RB CO."
        );
      }

      if (!this.state.sim) {
        recommendations.push(
          "Η SIM κρατά το σύστημα συνδεδεμένο όταν υπάρχει πρόβλημα στο internet."
        );
      }

      if (this.state.monitoring !== "yes") {
        recommendations.push(
          "Το Κέντρο Λήψης Σημάτων προσφέρει επαγγελματική διαχείριση συμβάντων."
        );
      }

      return recommendations;
    }

    render() {
      this.enforceRules();
      this.renderSteps();
      this.renderOptions();
      this.renderCounters();
      this.renderMotionSplit();
      this.renderColorSelectors();
      this.renderSummary();
      this.renderSecurityScore();
      this.renderNavigation();
      this.syncHiddenFields();
    }

    renderSteps() {
      this.steps.forEach((stepElement) => {
        const stepNumber = Number(
          stepElement.dataset.step
        );

        const active =
          stepNumber === this.state.currentStep;

        stepElement.hidden = !active;

        stepElement.classList.toggle(
          "is-active",
          active
        );

        stepElement.setAttribute(
          "aria-hidden",
          String(!active)
        );
      });

      this.root
        .querySelectorAll("[data-current-step]")
        .forEach((element) => {
          element.textContent = this.state.currentStep;
        });

      this.root
        .querySelectorAll("[data-total-steps]")
        .forEach((element) => {
          element.textContent = this.totalSteps;
        });

      const progress =
        (this.state.currentStep / this.totalSteps) * 100;

      this.root
        .querySelectorAll("[data-progress-bar]")
        .forEach((element) => {
          element.style.width = `${progress}%`;

          const progressContainer = element.closest(
            '[role="progressbar"]'
          );

          if (progressContainer) {
            progressContainer.setAttribute(
              "aria-valuenow",
              String(Math.round(progress))
            );
          }
        });
    }

    renderOptions() {
      this.root
        .querySelectorAll("[data-option]")
        .forEach((option) => {
          const field = option.dataset.option;
          const value = option.dataset.value;

          let selected = false;

          if (field === "sim") {
            selected =
              this.state.sim === (value === "true");
          } else {
            selected =
              String(this.state[field]) === String(value);
          }

          option.classList.toggle(
            "is-selected",
            selected
          );

          option.setAttribute(
            "aria-pressed",
            String(selected)
          );
        });
    }

    renderCounters() {
      this.root
        .querySelectorAll("[data-counter-value]")
        .forEach((element) => {
          const field = element.dataset.counterValue;

          if (field in this.state) {
            element.textContent = this.state[field];
          }
        });

      this.root
        .querySelectorAll("[data-counter-action]")
        .forEach((button) => {
          const field = button.dataset.counterAction;
          const direction = button.dataset.direction;
          const value = Number(this.state[field]) || 0;

          let disabled = false;

          if (
            direction === "decrease" &&
            value <= 0
          ) {
            disabled = true;
          }

          if (
            field === "motionCams" &&
            direction === "increase" &&
            value >= this.state.motionRooms
          ) {
            disabled = true;
          }

          button.disabled = disabled;
        });
    }

    renderMotionSplit() {
      const motionProtectQuantity = Math.max(
        0,
        this.state.motionRooms - this.state.motionCams
      );

      this.root
        .querySelectorAll("[data-motioncam-quantity]")
        .forEach((element) => {
          element.textContent = this.state.motionCams;
        });

      this.root
        .querySelectorAll("[data-motionprotect-quantity]")
        .forEach((element) => {
          element.textContent = motionProtectQuantity;
        });
    }

    renderColorSelectors() {
      const quantities = this.getQuantities();

      this.root
        .querySelectorAll("[data-color-group]")
        .forEach((group) => {
          const productId = group.dataset.colorGroup;
          const quantity = quantities[productId] || 0;
          const selectedColor =
            this.state.colors[productId] || "white";

          group.hidden = quantity <= 0;

          const quantityLabel = group.querySelector(
            `[data-color-quantity-for="${productId}"]`
          );

          if (quantityLabel) {
            quantityLabel.textContent = `${quantity} τεμ.`;
          }

          group
            .querySelectorAll("[data-color-choice]")
            .forEach((button) => {
              const color = button.dataset.colorValue;
              const selected = color === selectedColor;

              button.classList.toggle("is-selected", selected);
              button.setAttribute("aria-pressed", String(selected));

              button.hidden =
                productId === "streetsiren" &&
                color === "black";
            });

          const image = group.querySelector(
            `[data-color-product-image="${productId}"]`
          );

          if (image) {
            const sourceAttribute =
              selectedColor === "black"
                ? "data-black-src"
                : "data-white-src";

            const nextSource =
              image.getAttribute(sourceAttribute) ||
              image.getAttribute("data-white-src");

            if (
              nextSource &&
              image.getAttribute("src") !== nextSource
            ) {
              image.classList.add("is-changing");
              image.setAttribute("src", nextSource);

              window.setTimeout(() => {
                image.classList.remove("is-changing");
              }, 180);
            }

            const productName =
              group.querySelector(
                ".ajax-configurator__color-product-copy strong"
              )?.textContent?.trim() || "Ajax συσκευή";

            image.alt =
              `${productName} σε ${
                selectedColor === "black"
                  ? "μαύρο"
                  : "λευκό"
              } χρώμα`;
          }
        });
    }

    renderSummary() {
      const products = this.getSelectedProducts();
      const totals = this.calculateTotals();

      const list = this.root.querySelector(
        "[data-summary-products]"
      );

      if (list) {
        list.innerHTML = "";

        products.forEach((product) => {
          const item = document.createElement("li");

          item.className =
            "ajax-configurator__summary-item";

          const colorLabel =
            product.color === "black"
              ? "Μαύρο"
              : "Λευκό";

          item.innerHTML = `
            <div>
              <strong>
                ${this.escapeHtml(product.name)}
              </strong>

              <span class="ajax-configurator__summary-meta">
                ${product.quantity} ×
                ${this.money(product.price)}

                <i
                  class="ajax-configurator__summary-color ajax-configurator__summary-color--${product.color}"
                  aria-hidden="true"
                ></i>

                ${colorLabel}
              </span>
            </div>

            <strong>
              ${this.money(product.subtotal)}
            </strong>
          `;

          list.appendChild(item);
        });
      }

      this.setText(
        "[data-total-equipment]",
        this.money(totals.equipment)
      );

      this.setText(
        "[data-total-installation]",
        this.money(totals.installation)
      );

      this.setText(
        "[data-total-sim]",
        this.state.sim
          ? `${this.money(totals.simAnnual)} / έτος`
          : "Δεν επιλέχθηκε"
      );

      let monitoringText = "Δεν επιλέχθηκε";

      if (this.state.monitoring === "yes") {
        monitoringText =
          `${this.money(totals.monitoringMonthly)} / μήνα`;
      }

      if (this.state.monitoring === "info") {
        monitoringText = "Ζητήθηκαν πληροφορίες";
      }

      this.setText(
        "[data-total-monitoring]",
        monitoringText
      );

      this.setText(
        "[data-total-initial]",
        this.money(totals.initialTotal)
      );
    }

    renderSecurityScore() {
      const score = this.calculateSecurityScore();
      const label = this.getSecurityLabel(score);
      const recommendations = this.getRecommendations();

      this.setText(
        "[data-security-score]",
        `${score}/100`
      );

      this.setText(
        "[data-security-label]",
        label
      );

      this.root
        .querySelectorAll("[data-score-progress]")
        .forEach((element) => {
          element.style.width = `${score}%`;

          const progressContainer = element.closest(
            '[role="progressbar"]'
          );

          if (progressContainer) {
            progressContainer.setAttribute(
              "aria-valuenow",
              String(score)
            );
          }
        });

      const list = this.root.querySelector(
        "[data-recommendations]"
      );

      if (!list) {
        return;
      }

      list.innerHTML = "";

      recommendations.forEach((recommendation) => {
        const item = document.createElement("li");
        item.textContent = recommendation;
        list.appendChild(item);
      });

      list.hidden = recommendations.length === 0;
    }

    renderNavigation() {
      this.root
        .querySelectorAll("[data-prev-step]")
        .forEach((button) => {
          button.hidden = this.state.currentStep <= 1;
        });

      this.root
        .querySelectorAll("[data-next-step]")
        .forEach((button) => {
          button.hidden =
            this.state.currentStep >= this.totalSteps;
        });

      this.root
        .querySelectorAll("[data-submit-configurator]")
        .forEach((button) => {
          button.hidden =
            this.state.currentStep !== this.totalSteps;
        });
    }

    syncHiddenFields() {
      const totals = this.calculateTotals();
      const products = this.getSelectedProducts();
      const score = this.calculateSecurityScore();

      const payload = {
        version: CONFIG.version,

        propertyType: this.state.propertyType,

        entrances: this.state.entrances,
        balconyDoors: this.state.balconyDoors,
        windows: this.state.windows,

        motionRooms: this.state.motionRooms,
        motionCams: this.state.motionCams,

        motionProtects: Math.max(
          0,
          this.state.motionRooms - this.state.motionCams
        ),

        fireDetectors: this.state.fireDetectors,
        leakDetectors: this.state.leakDetectors,

        remotes: this.state.remotes,
        panicButtons: this.state.panicButtons,

        sim: this.state.sim,
        monitoring: this.state.monitoring,

        colors: this.state.colors,

        products: products.map((product) => ({
          id: product.id,
          name: product.name,
          quantity: product.quantity,
          color: product.color,
          unitPrice: product.price,
          subtotal: product.subtotal
        })),

        totals,
        securityScore: score,
        customer: this.state.customer
      };

      this.setInputValue(
        "[data-lead-json]",
        JSON.stringify(payload)
      );

      this.setInputValue(
        "[data-lead-summary]",
        this.buildSummary(payload)
      );

      this.setInputValue(
        "[data-lead-total]",
        this.money(totals.initialTotal)
      );

      this.setInputValue(
        "[data-lead-score]",
        `${score}/100`
      );
    }

    buildSummary(payload) {
      const lines = [
        `Iliria Security Configurator v${payload.version}`,
        "",
        `Τύπος χώρου: ${payload.propertyType}`,
        `Είσοδοι: ${payload.entrances}`,
        `Μπαλκονόπορτες: ${payload.balconyDoors}`,
        `Παράθυρα: ${payload.windows}`,
        `Χώροι κίνησης: ${payload.motionRooms}`,
        `MotionCam: ${payload.motionCams}`,
        `MotionProtect: ${payload.motionProtects}`,
        `FireProtect 2 RB CO: ${payload.fireDetectors}`,
        `LeaksProtect: ${payload.leakDetectors}`,
        `SpaceControl: ${payload.remotes}`,
        `Button Panic: ${payload.panicButtons}`,
        `SIM: ${payload.sim ? "Ναι" : "Όχι"}`,
        `Κέντρο Λήψης: ${this.monitoringLabel(
          payload.monitoring
        )}`,
        "",
        "Προϊόντα:"
      ];

      payload.products.forEach((product) => {
        const colorLabel =
          product.color === "black"
            ? "Μαύρο"
            : "Λευκό";

        lines.push(
          `- ${product.name}: ` +
          `${product.quantity} τεμ. · ` +
          `${colorLabel} · ` +
          `${this.money(product.subtotal)}`
        );
      });

      lines.push(
        "",
        `Εξοπλισμός: ${this.money(
          payload.totals.equipment
        )}`,
        `Εγκατάσταση: ${this.money(
          payload.totals.installation
        )}`,
        `SIM πρώτου έτους: ${this.money(
          payload.totals.simAnnual
        )}`,
        `Αρχικό σύνολο: ${this.money(
          payload.totals.initialTotal
        )}`,
        `Security Score: ${payload.securityScore}/100`
      );

      return lines.join("\n");
    }

    monitoringLabel(value) {
      if (value === "yes") {
        return "Ναι";
      }

      if (value === "info") {
        return "Θέλω περισσότερες πληροφορίες";
      }

      return "Όχι";
    }

    money(value) {
      return this.moneyFormatter.format(
        Number(value) || 0
      );
    }

    buildApiPayload() {
      const products = this.getSelectedProducts();
      const totals = this.calculateTotals();

      return {
        customer: {
          name: this.state.customer.name,
          email: this.state.customer.email,
          phone: this.state.customer.phone,
          city: this.state.customer.area,
          address: ""
        },
        items: products.map((product) => ({
          id: product.id,
          name: product.name,
          quantity: product.quantity,
          color: product.color,
          unitPrice: product.price,
          total: product.subtotal
        })),
        services: {
          installationSelected: true,
          simSelected: this.state.sim,
          monitoringSelected: this.state.monitoring === "yes",
          monitoringInfoRequested: this.state.monitoring === "info"
        },
        totals: {
          equipment: totals.equipment,
          installation: totals.installation,
          sim: totals.simAnnual,
          monitoring: totals.monitoringAnnual,
          grandTotal: totals.initialTotal + totals.monitoringAnnual
        },
        property: {
          type: this.state.propertyType,
          entrances: this.state.entrances,
          balconyDoors: this.state.balconyDoors,
          windows: this.state.windows,
          motionRooms: this.state.motionRooms,
          motionCams: this.state.motionCams,
          fireDetectors: this.state.fireDetectors,
          leakDetectors: this.state.leakDetectors,
          remotes: this.state.remotes,
          panicButtons: this.state.panicButtons
        },
        securityScore: this.calculateSecurityScore(),
        notes: this.state.customer.notes,
        source: "Shopify Ajax Configurator v3.2"
      };
    }

    async submitConfiguration(form) {
      if (!this.validateFinalForm()) {
        return;
      }

      const endpoint = this.root.dataset.apiUrl;
      const submitButton = this.root.querySelector(
        "[data-submit-configurator]"
      );

      if (!endpoint) {
        this.showMessage(
          "Δεν έχει οριστεί η διεύθυνση αποστολής. Επικοινωνήστε με την Iliria Security."
        );
        return;
      }

      this.clearMessage();
      this.syncHiddenFields();

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.dataset.originalText =
          submitButton.textContent;
        submitButton.textContent = "Αποστολή...";
      }

      try {
        const payload = this.buildApiPayload();
        const response = await fetch(endpoint, {
          method: "POST",
          redirect: "follow",
          headers: {
            "Content-Type": "text/plain;charset=utf-8"
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const result = await response.json();

        if (!result.success) {
          throw new Error(
            result.message || "Η αποστολή απέτυχε."
          );
        }

        this.showConfirmation(result, payload, form);
      } catch (error) {
        console.error(
          "Ajax Configurator submit error:",
          error
        );

        this.showMessage(
          "Δεν ολοκληρώθηκε η αποστολή. Δοκίμασε ξανά ή επικοινώνησε μαζί μας τηλεφωνικά."
        );
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent =
            submitButton.dataset.originalText ||
            "Αποστολή για τελική προσφορά";
        }
      }
    }

    showConfirmation(result, payload, form) {
      const confirmation = this.root.querySelector(
        "[data-configurator-confirmation]"
      );
      const configuratorInterface = this.root.querySelector(
        "[data-configurator-interface]"
      );

      if (!confirmation) {
        console.error(
          "Ajax Configurator: Δεν βρέθηκε το confirmation screen."
        );
        this.showMessage(
          "Το αίτημα καταχωρήθηκε, αλλά δεν ήταν δυνατή η εμφάνιση της επιβεβαίωσης."
        );
        return;
      }

      const colorName = (color) =>
        color === "black" ? "Μαύρο" : "Λευκό";

      const requestId = confirmation.querySelector(
        "[data-confirmation-request-id]"
      );
      const date = confirmation.querySelector(
        "[data-confirmation-date]"
      );
      const customerBox = confirmation.querySelector(
        "[data-confirmation-customer]"
      );
      const productsBox = confirmation.querySelector(
        "[data-confirmation-products]"
      );
      const productCount = confirmation.querySelector(
        "[data-confirmation-product-count]"
      );
      const totalsBox = confirmation.querySelector(
        "[data-confirmation-totals]"
      );

      if (requestId) {
        requestId.textContent =
          result.requestId ||
          result.requestID ||
          result.id ||
          "—";
      }

      if (date) {
        const submittedAt =
          result.submittedAt || result.date || result.timestamp || "";

        date.textContent = submittedAt
          ? `Υποβλήθηκε: ${submittedAt}`
          : "";
      }

      if (customerBox) {
        customerBox.innerHTML = `
          <p><strong>Ονοματεπώνυμο:</strong> ${this.escapeHtml(payload.customer.name)}</p>
          <p><strong>Τηλέφωνο:</strong> ${this.escapeHtml(payload.customer.phone)}</p>
          <p><strong>Email:</strong> ${this.escapeHtml(payload.customer.email)}</p>
          <p><strong>Περιοχή:</strong> ${this.escapeHtml(payload.customer.city || "—")}</p>
          <p><strong>Τύπος χώρου:</strong> ${this.escapeHtml(payload.property.type || "—")}</p>
        `;
      }

      if (productCount) {
        const count = payload.items.length;
        productCount.textContent =
          count === 1 ? "1 προϊόν" : `${count} προϊόντα`;
      }

      if (productsBox) {
        productsBox.innerHTML = payload.items
          .map(
            (item) => `
              <div class="ajax-configurator__confirmation-product">
                <div>
                  <strong>${this.escapeHtml(item.name)}</strong>
                  <span>${colorName(item.color)} · ${item.quantity} τεμ.</span>
                </div>
                <b>${this.money(item.total)}</b>
              </div>
            `
          )
          .join("");
      }

      if (totalsBox) {
        let monitoringText = "Δεν επιλέχθηκε";

        if (payload.services.monitoringSelected) {
          monitoringText = `${this.money(payload.totals.monitoring)} / έτος`;
        } else if (payload.services.monitoringInfoRequested) {
          monitoringText = "Ζητήθηκαν πληροφορίες";
        }

        totalsBox.innerHTML = `
          <div><span>Εξοπλισμός</span><strong>${this.money(payload.totals.equipment)}</strong></div>
          <div><span>Εγκατάσταση</span><strong>${this.money(payload.totals.installation)}</strong></div>
          <div><span>SIM πρώτου έτους</span><strong>${payload.services.simSelected ? this.money(payload.totals.sim) : "Δεν επιλέχθηκε"}</strong></div>
          <div><span>Κέντρο Λήψης Σημάτων</span><strong>${monitoringText}</strong></div>
          <div class="ajax-configurator__confirmation-grand-total">
            <span>Συνολικό εκτιμώμενο κόστος με ΦΠΑ</span>
            <strong>${this.money(payload.totals.grandTotal)}</strong>
          </div>
        `;
      }

      this.clearMessage();

      if (configuratorInterface) {
        configuratorInterface.hidden = true;
      } else if (form) {
        form.hidden = true;
      }

      confirmation.hidden = false;
      this.root.classList.add("is-confirmed");

      window.requestAnimationFrame(() => {
        confirmation.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    }

    resetConfigurator() {
      this.state = JSON.parse(
        JSON.stringify(DEFAULT_STATE)
      );

      this.root
        .querySelectorAll("[data-customer-field]")
        .forEach((field) => {
          field.value = "";
        });

      const configuratorInterface = this.root.querySelector(
        "[data-configurator-interface]"
      );
      const form = this.root.querySelector(
        "form.ajax-configurator__form"
      );
      const confirmation = this.root.querySelector(
        "[data-configurator-confirmation]"
      );

      if (configuratorInterface) {
        configuratorInterface.hidden = false;
      }

      if (form) {
        form.hidden = false;
        form.reset();
      }

      if (confirmation) {
        confirmation.hidden = true;
      }

      this.root.classList.remove("is-confirmed");
      this.clearMessage();
      this.render();
      this.root.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }

    setText(selector, value) {
      this.root
        .querySelectorAll(selector)
        .forEach((element) => {
          element.textContent = value;
        });
    }

    setInputValue(selector, value) {
      this.root
        .querySelectorAll(selector)
        .forEach((element) => {
          element.value = value;
        });
    }

    showMessage(message) {
      const box = this.root.querySelector(
        "[data-configurator-message]"
      );

      if (!box) {
        return;
      }

      box.textContent = message;
      box.hidden = false;

      box.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }

    clearMessage() {
      const box = this.root.querySelector(
        "[data-configurator-message]"
      );

      if (!box) {
        return;
      }

      box.textContent = "";
      box.hidden = true;
    }

    escapeHtml(value) {
      return String(value)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    }
  }

  function initializeConfigurators(scope = document) {
    scope
      .querySelectorAll("[data-ajax-configurator]")
      .forEach((root) => {
        if (root.dataset.initialized === "true") {
          return;
        }

        root.dataset.initialized = "true";
        new AjaxConfigurator(root);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initializeConfigurators()
    );
  } else {
    initializeConfigurators();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      initializeConfigurators(event.target);
    }
  );
})();